<template>
  <div class="mc-period-wrapper">
    <h4 class="ms-1">
      {{ $t('report.title.fleetUtilization') }}
    </h4>
    <b-form-group v-for="(field, key) in fields" :key="key">
      <div class="mc-period-group d-flex justify-content-between">
        <label v-if="field.hasTooltip">{{ $t(field._label) }}</label>
        <span v-if="field.hasTooltip" :id="`period-tooltip-info`">
          <i class="mc-fa icon-outline_info" />
        </span>
        <b-tooltip :target="`period-tooltip-info`" triggers="hover" placement="bottomRight">
          {{ $t('global.validation.reportPeriod') }}
        </b-tooltip>
      </div>
      <ValueHelpWrapper
        v-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="oldFormValues[field.name]"
        :fullObject="oldFullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput v-else v-bind="field">
        <template #help>
          <label v-if="field.isRequired" class="mt-1 fst-italic">
            <span class="text-danger">*</span> {{ $t('report.filters.required') }}
          </label>
        </template>
      </FormulateInput>
    </b-form-group>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import { getTableFilterFields } from './lib/tableFilterFields'

export default {
  components: {
    ValueHelpWrapper,
  },
  props: {
    formValues: {
      type: Object,
      default: () => {},
    },
    fullObjects: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      fields: getTableFilterFields.call(this).filter((field) => field.isShow === true),
      oldFormValues: {},
      oldFullObjects: {},
    }
  },
  watch: {
    formValues: {
      handler(newVal) {
        if (Object.keys(newVal).length) {
          this.oldFormValues = cloneDeep(newVal)
        }
      },
      immediate: true,
    },

    fullObjects: {
      handler(newVal) {
        if (Object.keys(newVal).length) {
          this.oldFullObjects = cloneDeep(newVal)
        }
      },
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-period-wrapper {
  :deep(.mc-period-group) {
    padding: 5px 5px 0 5px;
  }
}
</style>
